import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App baseUrl={baseUrl} />
  </React.StrictMode>
);
